import script from "./xtx-pagination.vue?vue&type=script&setup=true&lang=js"
export * from "./xtx-pagination.vue?vue&type=script&setup=true&lang=js"

import "./xtx-pagination.vue?vue&type=style&index=0&id=5a6bb2e6&scoped=true&lang=less"

import exportComponent from "D:\\hbuilderxpro\\jxshop\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a6bb2e6"]])

export default __exports__